(ns teamoesterreich.admin-mode.data.lr-incident
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))


(defn get-lr-incident-list [params done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-incident")
              (fn [r-list status]
                (when (= status 200)
                  (done-fn
                    (js->clj (json/parse r-list)))
                    ))))




